<template>
  <div>
    <InputMoney
        v-model="value_cash"
        label="Preço"
        name="value_cash"
        :errors="errors"
    />

    <InputMoney
        v-model="value_old"
        label="Preço Promocional"
        name="value_old"
        :errors="errors"
    />

    <InputNumber
        v-model="quantity"
        label="Quantidade"
        name="quantity"
        :errors="errors"
    />

    <InputMoney
        v-model="discount"
        label="Desconto"
        name="discount"
        :errors="errors"
    />
  </div>
</template>

<script>
import InputMoney from "../inputs/InputMoney.vue";
import InputNumber from "../inputs/InputNumber.vue";

export default {
  name: "DadosDescontoPercentualSegundaUnidade",
  components: {InputMoney, InputNumber},
  data() {
    return {
      errors: [],
      value_cash: null,
      value_old: null,
      quantity: null,
      discount: null,
    }
  },

  watch: {
    value_cash() {
      this.calculate();
    },
    quantity() {
      this.calculate();
    },
    discount() {
      this.calculate();
    }
  },

  methods: {
    calculate() {
      const valueCash = this.parseToFloat(this.value_cash);
      const quantity = this.parseToFloat(this.quantity);
      const discount = this.parseToFloat(this.discount);

      if (valueCash <= 0 || quantity <= 0 || discount <= 0) {
        this.value_old = this.cleanValue(valueCash)
        return
      }

      const result = (1 - ((discount / quantity) / 100)) * valueCash
      this.value_old = this.cleanValue(result)
    },

    cleanValue: function (value) {
      if (value) {
        value = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        value = (/\.[0-9]{1}$/g.test(value)) ? value + '0' : value;
        value = (/^\d+$/.test(value)) ? value + '.00' : value;
        value = value.toString().replace('.', ',');
      }
      return value;
    },

    parseToFloat(value) {
      if (value) {
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/rules/DadosDescontoPercentualSegundaUnidade.vue